module.exports = __webpack_public_path__ + "img/refreshBlog.f9f85a3f.svg";